import { Flex } from '@modusign/design-system';
import { ReactNode } from 'react';

import FileHashHeader from '../FileHashHeader';

interface FileHashPageLayoutProps {
  children: ReactNode;
}

export default function FileHashPageLayout({ children }: FileHashPageLayoutProps) {
  return (
    <Flex alignItems="center" flexDirection="column" width="100%">
      <FileHashHeader />
      {children}
    </Flex>
  );
}
